export default {
  slices: [
    {
      field: 'ad_type',
      display: 'Ad Type',
      map: {
        'social_video': {
          display: 'Video',
          sortOrder: 1
        },
        'social_post': {
          display: 'Social Post',
          sortOrder: 2
        },
        'disney_radio': {
          display: 'Radio',
          sortOrder: 3
        },
        'disney_ooh': {
          display: 'OOH',
          sortOrder: 4
        }
      }
    },
    {
      field: 'ad_categories',
      display: 'Ad Category',
      variant: 'multigroup',
      map: {
        'disney_all_ads': {
          display: 'All Ads',
          sortOrder: 1,
          multigroup: true,
        },
        'brand_service_only': {
          display: 'Streaming - Brand (Service Only)',
          sortOrder: 2
        },
        'brand_multi_show': {
          display: 'Streaming - Brand (Multi-Show)',
          sortOrder: 3
        },
        'content_single_show': {
          display: 'Streaming - Content (Single-Show) ',
          sortOrder: 4
        },
        'content_video_ott': {
          display: 'Streaming - Content (Multi-Show)',
          sortOrder: 5
        },
        'stream_brand': {
          display: 'Streaming - Brand',
          sortOrder: 7,
          multigroup: true,
        },
        'stream_content': {
          display: 'Streaming - Content',
          sortOrder: 8,
          multigroup: true,
        },
        'all_streaming': {
          display: 'All Streaming',
          sortOrder: 6,
          multigroup: true
        },
        'live_tv': {
          display: 'Live TV',
          sortOrder: 9
        },
        'all_svod': {
          display: 'All SVOD',
          sortOrder: 5,
          multigroup: true
        }
      }
    }
  ]
};



// WEBPACK FOOTER //
// ./src/app/configuration/DisneyHulu/config/metadata.js